import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./app.tsx";
import ErrorBoundary from "../components/errorBoundary";

const container = document.getElementById("indexApp");
if (container) {
	createRoot(container).render(
		<ErrorBoundary>
			<App
				clubId={container.dataset.clubId || null}
				memberRegistrationUrl={container.dataset.memberRegistrationUrl || null}
				memberLoginUrl={container.dataset.memberLoginUrl || null}
				passwordProfile={container.dataset.passwordProfile || null}
			/>
		</ErrorBoundary>
	);
}
